<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">e-Mail Komunikator</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$store.commit('setAddCustomMeetingRegardingUser', false);}">
                    <img src="@/assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">Imię</label>
                <section class="esesja-modal__row">
                    <input type="text" class="esesja-modal__wraper__body__input" placecholder="Imię" v-model="formModel.name" required />
                </section>
                <label class="esesja-modal__wraper__body__label">Naziwsko</label>
                <section class="esesja-modal__row">
                    <input type="text" class="esesja-modal__wraper__body__input" placecholder="Nazwisko" v-model="formModel.surname" required />
                </section>
                <label class="esesja-modal__wraper__body__label">e-Mail</label>
                <section class="esesja-modal__row">
                    <input type="email" class="esesja-modal__wraper__body__input" placecholder="e-Mail" v-model="formModel.email" required />
                </section>
                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="() => { $store.commit('setAddCustomMeetingRegardingUser', false); }"> Anuluj</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="add">Wyślij</button>
                </section>
            </perfect-scrollbar>
        </section>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "AddCutomMeetingRegardingUser",
        data() {
            return {
                formModel: {
                    name: "",
                    surname: "",
                    email: "",
                }
            }
        },
        methods: {
            addTemporaryUser() {
                try {
                    this.$store.commit("showLoader")
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '@/assets/scss/esesja-modal.scss';
</style>